import React from 'react';
import {Button,
    Paper,
    MenuItem,
    Menu,
    Link
} from '@mui/material';
import ListIcon from '@mui/icons-material/List';
import SettingsIcon from '@mui/icons-material/Settings';
import ListAltIcon from '@mui/icons-material/ListAlt';
import {useSelector} from "react-redux";
import {State} from "../reducer";
import {ADMIN_ROLE} from "../const";
import {Link as RouterLink} from "react-router-dom";


export default function HeaderMenu() {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const auth = useSelector(({auth}: State) => auth);

    const handleClick = (event : any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div style={{ display: 'flex'}}>
            <div>
                <Button aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={(event) => handleClick(event)}
                        color="inherit"
                >
                    <ListIcon/> <label style={{cursor: 'pointer'}}>Menu</label>
                </Button>
                <Paper>
                    <Menu id="simple-menu" anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}>
                        <MenuItem onClick={handleClose}>
                            <label>
                                <Link
                                    to={`/`}  color={"inherit"}
                                    component={RouterLink} underline={"none"}>
                                    <ListAltIcon style={{marginRight: 5}}/>
                                    Liste Ouvrages
                                </Link>
                            </label>
                        </MenuItem>
                        {
                            auth.roles.indexOf(ADMIN_ROLE) !== -1 &&

                            <MenuItem onClick={handleClose}>
                                <label>
                                    <Link
                                        to={`/parametre`} color={"inherit"}
                                        component={RouterLink} underline={"none"}>
                                        <SettingsIcon style={{marginRight: 5}}/>
                                        Paramétrage
                                    </Link>
                                </label>
                            </MenuItem>
                        }
                    </Menu>
                </Paper>
            </div>
        </div>
    );
}
